import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Flex, Text } from '@spotify-internal/encore-web';
import { ConfidenceLogo } from '@spotify/confidence-core-react';

import styles from './TransitionScreen.module.css';

export type TransitionScreenProps = {
  title: ReactNode;
  branding?: ReactNode;
  graphics?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  helperText?: ReactNode;
};

export const TransitionScreen = ({
  title,
  branding,
  graphics = (
    <Link to="/" aria-label="Go to homepage">
      <ConfidenceLogo className={styles.logo} />
    </Link>
  ),
  description,
  actions,
  helperText,
}: TransitionScreenProps) => (
  <div className={styles.root}>
    {branding}
    <Flex
      className={styles.wrapper}
      alignItems="center"
      justifyContent="center"
    >
      <div className={styles.content}>
        {graphics && (
          <Flex
            className={styles.graphics}
            justifyContent="center"
            alignItems="center"
          >
            {graphics}
          </Flex>
        )}
        <Text as="h1" variant="titleLarge" className={styles.title}>
          {title}
        </Text>
        {description && (
          <Text
            as="div"
            variant="bodyMedium"
            semanticColor="textSubdued"
            className={styles.description}
          >
            {description}
          </Text>
        )}
        {actions && (
          <Flex
            className={styles.actions}
            direction="row"
            gap="tighter-2"
            alignItems="center"
            justifyContent="center"
          >
            {actions}
          </Flex>
        )}
        {helperText && (
          <Text
            variant="bodySmall"
            semanticColor="textSubdued"
            as="div"
            className={styles.helperText}
          >
            {helperText}
          </Text>
        )}
      </div>
    </Flex>
  </div>
);
